import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { addOutline } from 'ionicons/icons';
import OrderTable from './OrderTable';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllOrderAsync, getAllOrderStatusAsync } from '@application/features/orders/orderThunk';
import { useEffect, useState } from 'react';
import VnPagination from '@ui/components/VnPagination';
import { useNavigate } from 'react-router-dom';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const Orders = () => {
    VnDocumentTitle('Visser Bestellingen');
    const handleAddOrderClick = () => {
        navigate(`/admin/OrderTabs`);
    };
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { orders, orderRequest } = useAppSelector((state) => state.order);
    const [searchOrderText, setSearchOrderText] = useState('');
    const defaultSortingCriteria = {
        sortColumnKey: 'created',
        sortDirection: 'desc'
    };
    const defaultOrderFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        orderNumber: null,
        supplierName: null,
        workorderNumber: null,
        debtorName: null,
        workorderDescription: null,
        orderDate: null,
        deliveryDate: null,
        statusName: null,
        created: null,
        createdBy: null
    };
    const [orderFilterValues, setOrderFilterValues] = useState(defaultOrderFilterValues);
    const onRowClick = (rowId) => {
        window.open(`/admin/OrderTabs/${rowId}`, '_blank');
    };
    // useEffect(() => {
    //     dispatch(getAllOrderAsync(orderRequest));
    // }, [dispatch, orderRequest]);
    /*Sorting and Filtering region */
    useEffect(() => {
        dispatch(getAllOrderAsync(orderFilterValues));
        dispatch(getAllOrderStatusAsync());
    }, []);
    const updateOrderFilterValues = (newValues) => {
        setOrderFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchOrderHandler(searchText) {
        updateOrderFilterValues({ filter: searchText });
        dispatch(getAllOrderAsync({
            ...orderFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function onOrdersPageChange(pageNumber) {
        updateOrderFilterValues({ pageNumber });
        dispatch(getAllOrderAsync({
            ...orderFilterValues,
            pageNumber
        }));
    }
    function OrderSortingHandler(data) {
        updateOrderFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllOrderAsync({
            ...orderFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function OrderFilteringHandler(data) {
        data.pageNumber = 1;
        updateOrderFilterValues(data);
        dispatch(getAllOrderAsync({
            ...orderFilterValues,
            ...data
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '2rem'
                }, children: [_jsx("h4", { children: "Bestellingen" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Bestellingen', onClick: handleAddOrderClick, isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) }) })] }), _jsx("div", { className: 'mt-0', children: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchOrderHandler }), _jsx(OrderTable, { orders: orders?.items, onRowClick: onRowClick, onSorting: OrderSortingHandler, onFilter: OrderFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: orders && (_jsx(VnPagination, { currentPage: orders?.pageNumber, totalPages: orders?.totalPages, onPageChange: onOrdersPageChange })) })] }) })] }));
};
export default Orders;
